import React, { useRef } from 'react'
import styles from '../CollectionDetails.module.scss'
import SALink from 'components/SALink'
import useCollectionDetailsActions from '../hooks/useCollectionDetailsActions'
import { AdminUrlLinks } from '../types'
import DeleteCollectionModal, { DELETE_COLLECTION_MODAL } from './DeleteCollectionModal'
import useModal from 'hooks/useModal'
import CreateCollectionsModal, { CreateCollectionsModalApi } from './CreateCollectionsModal'
import useQA from 'hooks/useQA'

type CollectionDetailsActionsProps = {
  adminUrlLinks: AdminUrlLinks
  idUserCollection: number
}

const CollectionDetailsActions = ({
  adminUrlLinks,
  idUserCollection,
}: CollectionDetailsActionsProps) => {
  const { testId } = useQA()
  const { showModal, closeModal } = useModal()
  const createCollectionsModalRef = useRef<CreateCollectionsModalApi>(null)

  const openDeleteModal = () => {
    showModal(DELETE_COLLECTION_MODAL)
  }

  const {
    collectionDetailsActions,
    handleCreateCollectionOnSuccess,
  } = useCollectionDetailsActions({ adminUrlLinks, createCollectionsModalRef, openDeleteModal })

  const visibleCollectionActions = collectionDetailsActions.filter(({ isHidden }) => !isHidden)

  return (
    <div
      className={styles.collectionDetailsActionsContainer}
      {...testId('collection-details-actions-container')}
    >
      {visibleCollectionActions.map(({ title, label, href, onClick }, index) => (
        <>
          <SALink key={title} href={href} onClick={onClick} title={title}>
            {label}
          </SALink>
          {index !== visibleCollectionActions.length - 1 && '/'}
        </>
      ))}
      <CreateCollectionsModal
        ref={createCollectionsModalRef}
        onSuccess={handleCreateCollectionOnSuccess}
      />
      <DeleteCollectionModal
        onClose={closeModal}
        idUserCollection={idUserCollection}
        collectionsUrl={adminUrlLinks.collectionsUrl}
      />
    </div>
  )
}

export default CollectionDetailsActions
